//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VTextField, VSelect } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';
import phoneFormats from './phoneFormats.js';
import { validatePhoneNumberLength, AsYouType } from 'libphonenumber-js';
import parseMax from 'libphonenumber-js/max';

export default {
  name: 'NsPhoneNumberLib',
  components: {
    NsIcon,
    VTextField,
    VSelect,
  },
  props: {
    /**
     * Countries as a key:value object
     *  -- example: AR:"Argentina"
     * {
     *   AR: "Argentina",
     *   AT: "Austria"
     * }
     */
    countryNames: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Field Label
     */
    label: {
      type: String,
      default: 'Mobile Phone',
    },
    /**
     * Required message
     */
    errorMessage: {
      type: String,
      default: 'This field is required',
    },
    /**
     * Invalid Message
     */
    invalidMessage: {
      type: String,
      default: 'Invalid Phone Number Format',
    },
    /** Invalid Mobile number */
    invalidMobileMessage: {
      type: String,
      default: 'This is not a valid Mobile number',
    },
    /**
     * Hide details
     */
    hideDetails: {
      type: Boolean,
      default: false,
    },
    /**
     * Disable the country prefix
     */
    disablePrefix: {
      type: Boolean,
      default: false,
    },
    /**
     * Default country code
     */
    country: {
      type: String,
      default: 'US',
    },
    number: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false,
      mobilePhoneNumber: { country: this.country, number: this.number },
      form: {},
      rules: [
        (v) => (v || '').length > 0 || this.errorMessage,
        () => this.isValidPhoneNumber || this.invalidMessage,
        () => this.isMobile || this.invalidMobileMessage,
      ],
      phoneValid: null,
      menuProps: { minWidth: 350, offsetY: true, flat: true },
      focused: false,
    };
  },
  computed: {
    isValidPhoneNumber() {
      if (this.mobilePhoneNumber.number && this.validateLength == undefined) {
        return parseMax(
          this.mobilePhoneNumber.number,
          this.mobilePhoneNumber.country
        ).isValid();
      }
      return false;
    },
    isMobile() {
      if (
        this.mobilePhoneNumber.number &&
        this.mobilePhoneNumber.country !== 'JP' &&
        this.validateLength == undefined
      ) {
        const phoneType = parseMax(
          this.mobilePhoneNumber.number,
          this.mobilePhoneNumber.country
        ).getType();
        return phoneType === 'MOBILE' || phoneType === 'FIXED_LINE_OR_MOBILE';
      } else if (this.mobilePhoneNumber.country === 'JP') {
        return true;
      }
      return false;
    },
    validateLength() {
      return validatePhoneNumberLength(
        this.mobilePhoneNumber.number,
        this.mobilePhoneNumber.country
      );
    },
    countryList() {
      let countryList;
      // if countryNames is given as a prop
      let countryCodes = Object.keys(this.countryNames);
      if (countryCodes.length > 0) {
        countryList = countryCodes.reduce((acc, code) => {
          if (phoneFormats[code]) {
            acc.push(
              this.createCountryItem(
                this.countryNames[code],
                phoneFormats[code].countryPhoneCode,
                code
              )
            );
          }

          return acc;
        }, []);
      } else {
        // use default phoneFormats
        countryCodes = Object.keys(phoneFormats);
        countryList = countryCodes.map((code) =>
          this.createCountryItem(
            phoneFormats[code].countryName,
            phoneFormats[code].countryPhoneCode,
            code
          )
        );
      }

      countryList.sort((v1, v2) => v1.text.localeCompare(v2.text));

      return countryList;
    },
  },
  watch: {
    country() {
      this.changedMobileCountry(this.country);
    },
    number(newNumber) {
      if (newNumber !== this.mobilePhoneNumber.number) {
        this.mobilePhoneNumber.number = newNumber;
        this.receiveInput();
      }
    },
  },
  created() {
    this.changedMobileCountry(this.country);
  },
  methods: {
    createCountryItem(countryName, prefix, value) {
      return {
        text: `${countryName} (${prefix})`,
        value,
      };
    },
    closeDialog() {
      this.$emit('closeDialog');
      this.dialogError = null;
    },
    changedMobileCountry(value) {
      let countryFormat = phoneFormats[value];
      this.phonePrefix = countryFormat.countryPhoneCode;
      this.mobilePhoneNumber.country = value;
    },
    receiveBlur() {
      this.focused = false;
      this.receiveError();

      if (
        this.mobilePhoneNumber.number &&
        this.validateLength !== 'TOO_SHORT' &&
        this.validateLength !== 'TOO_LONG' &&
        this.validateLength == undefined &&
        this.validateLength !== 'NOT_A_NUMBER'
      ) {
        const number = parseMax(
          this.mobilePhoneNumber.number,
          this.mobilePhoneNumber.country
        );
        const e164Number = number.format('E.164');
        this.$emit(
          'e164',
          (this.updatedPhoneObject = {
            country: this.mobilePhoneNumber.country,
            number: e164Number,
          })
        );
        const nationalNumber = number.formatNational().replace(/[^0-9]/g, '');
        this.$emit(
          'input',
          (this.formattedNumber = {
            country: this.mobilePhoneNumber.country,
            number: nationalNumber,
          })
        );
      }
    },
    receiveInput() {
      this.mobilePhoneNumber.number = new AsYouType(
        this.mobilePhoneNumber.country
      ).input(this.mobilePhoneNumber.number);
      this.receiveError();
    },
    receiveError() {
      const valid = this.rules.every(
        (fn) => fn(this.mobilePhoneNumber.number) === true
      );
      this.$emit('update:error', (this.error = !valid));
    },
    updatePhone() {
      const self = this;
      const updatedMobilePhoneNumber = {
        phoneNumbers: {
          mobile: {
            country: self.mobilePhoneNumber.country,
            value: self.mobilePhoneNumber.number,
          },
        },
      };
      this.$emit('phoneNumberUpdated', updatedMobilePhoneNumber);
    },
  },
};
